import React from 'react';
export function Divider() {
  return <div className="divider" data-id="element-61">
      <span data-id="element-62">✦</span>
    </div>;
}